module.exports = __webpack_public_path__ + "static/media/1_pl.90f56dea.png";